<template>
  <div class="clm-form-info" :class="{'err' : isError}">
    <div class="clm-form-info__img">
      <img :src="cIconSrc">
    </div>
    <div class="clm-form-info__text">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "a-report",
  props: {
    isError: {
      type: [String, Boolean],
      default: false
    }
  },
  computed: {
    cIconSrc() {
      return (this.isError) ? '/local/img/form/info-red.svg' : '/local/img/form/info-orange.svg';
    }
  }
}
</script>